import React, { useEffect, useState } from 'react';
import { fetchCollection } from './utils';
import { useNavigate } from 'react-router-dom';
import './login_signup.css';

function ListGolfCourses() {
    const [loading, setLoading] = useState(true);
    const [golfCourses, setGolfCourses] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        async function fetchData() {
            setLoading(true);
            const coursesLocal = [];
            const docs = await fetchCollection("golfCourses");
            docs.forEach(doc => {
                coursesLocal.push({
                    id: doc.id,
                    ...doc.data()
                });
            });
            setGolfCourses(coursesLocal);
            setLoading(false);
        }
        fetchData();
    }, []);

    if (loading) {
        return (
            <div className="admin-login-bg">
                <div className="admin-login-card">
                    <div className="admin-login-loading">
                        <div className="admin-login-spinner"></div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="admin-login-bg">
            <div className="admin-login-card" style={{ maxWidth: 900 }}>
                <h1 className="admin-login-title">All Golf Courses</h1>
                <button
                    className="admin-login-btn"
                    type="button"
                    style={{ marginBottom: "1.5rem", padding: "0.4rem 1.1rem", fontSize: "0.97rem" }}
                    onClick={() => navigate('/admin')}
                >
                    ← Back to Admin Home
                </button>
                <div style={{ display: "flex", flexDirection: "column", gap: "1.2rem", marginTop: "2rem" }}>
                    {golfCourses.map(course => (
                        <div
                            key={course.id}
                            className="admin-list-card"
                            style={{
                                border: "1px solid #e5e7eb",
                                borderRadius: "1rem",
                                padding: "1.2rem 1.5rem",
                                background: "#f9fafb",
                                boxShadow: "0 2px 8px rgba(37,99,235,0.06)",
                                cursor: "pointer",
                                transition: "box-shadow 0.15s, transform 0.1s"
                            }}
                            onClick={() => navigate(`/admin/editGolfCourse?${course.id}`)}
                        >
                            <div style={{ fontSize: "1.2rem", fontWeight: 600, color: "#2563eb", marginBottom: "0.5rem" }}>
                                {course.name}
                            </div>
                            <div style={{ display: "flex", flexWrap: "wrap", gap: "1.5rem", fontSize: "1rem", color: "#374151" }}>
                                <div><b>City:</b> {course.city || "-"}</div>
                                <div><b>State/Province:</b> {course.state || "-"}</div>
                                <div><b>Country:</b> {course.country || "-"}</div>
                                <div>
                                    <b>Website:</b>{" "}
                                    {course.website ? (
                                        <a
                                            href={course.website}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{ color: "#2563eb", textDecoration: "underline" }}
                                            onClick={e => e.stopPropagation()}
                                        >
                                            {course.website}
                                        </a>
                                    ) : "-"}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default ListGolfCourses;